import { Button } from '@ipfabric/ui-components/Button/Button';

type EditFooterProps = {
  isAddMode: boolean;
  closeModal: () => void;
  onOpenTestPanel: () => void;
  onSubmitRule: () => void;
  testRuleAvailable: boolean;
};

export const EditFooter = ({
  isAddMode,
  closeModal,
  onOpenTestPanel,
  onSubmitRule,
  testRuleAvailable,
}: EditFooterProps) => (
  <div className='flex gap-xs'>
    <Button
      className='flex-1'
      dataTestId='site-separation-save-rule'
      icon='fa-floppy-disk'
      onClick={onSubmitRule}
      type='submit'
      variant='primary'
    >
      {isAddMode ? 'Add rule' : 'Save changes'}
    </Button>
    {testRuleAvailable && (
      <Button
        className='flex-1'
        dataTestId='site-separation-test-rule'
        onClick={onOpenTestPanel}
        type='button'
        variant='outline'
      >
        Test rule
      </Button>
    )}
    <Button className='flex-1' variant='outline' onClick={closeModal}>
      Close
    </Button>
  </div>
);

type TestFooterProps = {
  onApply: () => void;
  onRevert: () => void;
};

export const TestFooter = ({ onApply, onRevert }: TestFooterProps) => (
  <div className='flex gap-xs'>
    <Button
      className='flex-1'
      dataTestId='site-separation-apply-used-expression'
      icon='fa-floppy-disk'
      onClick={onApply}
      type='button'
      variant='primary'
    >
      Apply used expression
    </Button>
    <Button
      className='flex-1'
      dataTestId='site-separation-revert-test-expression'
      onClick={onRevert}
      type='button'
      variant='outline'
    >
      Revert changes
    </Button>
  </div>
);
